import { schema } from 'normalizr';

// Roles
export const roleSchema = new schema.Entity('roles');
export const rolesSchema = new schema.Array(roleSchema);

// Dashboard
export const dashboardSchema = new schema.Entity('dashboards');
export const dashboardsSchema = new schema.Array(dashboardSchema);

// Users
export const userSchema = new schema.Entity(
  'users',
  {
    roles: rolesSchema,
  },
  {
    processStrategy: entity => ({
      ...entity,
      fullName: entity.firstName && entity.lastName ? `${entity.firstName} ${entity.lastName}` : entity.email,
    }),
  },
);
export const usersSchema = new schema.Array(userSchema);

// Files
export const fileSchema = new schema.Entity('files');
export const filesSchema = new schema.Array(fileSchema);

// Spaces
export const spaceSchema = new schema.Entity('spaces');
export const spacesSchema = new schema.Array(spaceSchema);

// Tags
export const tagSchema = new schema.Entity('tags');
export const tagsSchema = new schema.Array(tagSchema);

// Mailing lists
export const mailingListSchema = new schema.Entity('mailingLists');
export const mailingListsSchema = new schema.Array(mailingListSchema);

// Folders
const folder = new schema.Entity('folders', undefined, {
  processStrategy: entity => ({
    ...entity,
    // Add route to each entity to simplify linking
    route: entity.space && entity.id ? `/spaces/${entity.space}/documents/folder/${entity.id}` : '/',
    pathIds: entity.path.split('.').map(x => parseInt(x, 10)),
  }),
});
const folders = new schema.Array(folder);
folder.define({
  space: spaceSchema,
  parent: folder,
  children: folders,
  createdBy: userSchema,
});
export const folderSchema = folder;
export const foldersSchema = folders;

// Documents
export const documentSchema = new schema.Entity(
  'documents',
  {
    folder: folderSchema,
    tags: tagsSchema,
    createdBy: userSchema,
    space: spaceSchema,
  },
  {
    // Add route to each entity to simplify linking
    processStrategy: entity => ({
      ...entity,
      route: entity.folder
        ? `/spaces/${entity.space}/documents/folder/${entity.folder}/document/${entity.id}`
        : `/spaces/${entity.space}/documents/document/${entity.id}`,
    }),
  },
);
export const documentsSchema = new schema.Array(documentSchema);

// Documents or folders (needed for feed)
export const documentsOrFoldersSchema = new schema.Array(
  {
    documents: documentSchema,
    folders: folderSchema,
  },
  value => (value.file ? 'documents' : 'folders'),
); // eslint-disable-line

export const documentOrFolderUnionSchema = new schema.Union(
  {
    document: documentSchema,
    folder: folderSchema,
  },
  'entityType',
);

export const documentsOrFoldersUnionSchema = new schema.Array(documentOrFolderUnionSchema);

export const favoriteSchema = new schema.Entity('favorites', {
  favorite: documentOrFolderUnionSchema,
});

export const favoritesSchema = new schema.Array(favoriteSchema);

// Permissions
export const globalPermissionSchema = new schema.Entity('globalPermissions');
export const globalPermissionsSchema = new schema.Array(globalPermissionSchema);

export const aclSidSchema = new schema.Entity('aclSids');
export const aclSidsSchema = new schema.Array(aclSidSchema);

const aclObjectIdentity = new schema.Entity('aclObjectIdentities');
aclObjectIdentity.define({
  parentObject: aclObjectIdentity,
});
export const aclObjectIdentitySchema = aclObjectIdentity;
export const aclObjectIdentitiesSchema = new schema.Array(aclObjectIdentitySchema);

export const permissionSchema = new schema.Entity(
  'permissions',
  {
    objectIdentityId: aclObjectIdentitySchema,
  },
  {
    idAttribute: 'objectIdentityId',
  },
);
export const permissionsSchema = new schema.Array(permissionSchema);
export const permissionsMapSchema = new schema.Values(permissionSchema);

// Contacts
export const contactSchema = new schema.Entity('contacts', {
  user: userSchema,
});
export const contactsSchema = new schema.Array(contactSchema);
